export default __webpack_public_path__ + "static/media/group-add-icon.d168b645.svg";